import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { CostGridBlockValueComponent } from "./cost-grid-block-value.component";
import { MatTableModule } from "@angular/material/table";
import { PriceModule } from "libraries/component/price/price.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { CostGridBlockCostCurrencyModule } from "./cost-grid-block-cost-currency/cost-grid-block-cost-currency.module";
import { CurrencyListResourceModule } from "libraries/service/resources/currency-list/currency-list-resource.module";

import { CellPriceModule } from "libraries/component/table/cell-price/cell-price.module";
import { QuotationPricePipesModule } from "app_quotation/shared/pipes/quotation-price-pipes.module";

@NgModule({
 imports: [
     CommonModule,
     MatTableModule,
     PriceModule,
     NotificationModule,
     CostGridBlockCostCurrencyModule,
     CurrencyListResourceModule,
     CellPriceModule,
     QuotationPricePipesModule
 ],
 exports: [
     CostGridBlockValueComponent
 ],
 declarations: [
     CostGridBlockValueComponent
 ],
 providers: [],
})
export class CostGridBlockValueModule { }
